
import {
  defineComponent, reactive, toRefs, computed,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ManagementFrame from '@/components/ui/managementFrame/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/icons/back.svg';
import { Button, Pagination, Table } from 'ant-design-vue';
import useHooks from '@/hooks/index.hooks';
import useReportHooks, { TableDataTeaMember } from '@/hooks/report.hooks';
import reportService from '@/services/report.services';
import { Page } from '@/interface/index.interface';
import { cloneDeep } from '@/lib';
import { definitions } from '@/types/api';

export default defineComponent({
  components: {
    ManagementFrame,
    SvgIcon,
    aButton: Button,
    aPagination: Pagination,
    aTable: Table,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { getPageOption } = useHooks();
    const reportHooks = useReportHooks();
    const { queryExperimentInfoById } = reportService();
    const tableData = reactive<Page & TableDataTeaMember>({
      tableList: [],
      tableLoading: false,
      columns: reportHooks.columnTeaMember(),
      experimentName: '',
      /** */
      pageNo: 1,
      pageSize: 10,
      total: 0,
      pageOption: cloneDeep(getPageOption),
    });

    const getInfo = async () => {
      const info = await queryExperimentInfoById(route.params.experimentId as string);
      tableData.experimentName = info.experimentName || '';
    };
    const getList = async () => {
      tableData.tableLoading = true;
      const { pageNo, pageSize } = tableData;
      const { list, total } = await reportHooks.listExperimentMemberReport({ pageNo, pageSize, experimentId: route.params.experimentId as string });
      Object.assign(tableData, {
        tableList: list, total, tableLoading: false,
      });
    };

    const tableMethod = reactive({
      /** 禁用查看-学生状态 */
      stuStatus: computed(() => (record: definitions['ExperimentScorePersonnelResponse']) => {
        /** 只有实验结束才能看详情 */
        if (record.groupStatus === 2) return false;
        return true;
      }),
      /** 进入报告详情页 */
      gotoInfo: (record: definitions['ExperimentScorePersonnelResponse']) => {
        const experimentId = route.params.experimentId as string;
        console.log(record);
        /** 设置点击的用户信息 */
        reportHooks.currentReportStuInfo.set(record.code || '', record.name || '');
        router.push({
          path: `/Teacher/reportInfo/${experimentId}/${record.code}`,
        });
      },
      /** 返回 */
      back: () => {
        router.back();
      },
    });

    const pageMethod = reactive({
      showSizeChange: (_: unknown, size: number) => {
        tableData.pageSize = size;
        tableData.pageNo = 1;
        getList();
      },
      pageChange: (page: number) => {
        tableData.pageNo = page;
        getList();
      },
    });
    getInfo();
    getList();
    console.log(route.params.experimentId, 'experimentId');
    return {
      ...toRefs(tableData),
      ...toRefs(tableMethod),
      ...toRefs(pageMethod),
    };
  },
});
